module.exports = __webpack_public_path__ + "static/media/unionpay.dbb0e487.png";